<template>
  <div class="check">
    <div class="check_title">
      {{ $t("message.DataRegistration.check.already_data") }}
    </div>
    <div v-if="form" class="check_form_content">
      <Quota :data="form.quota"></Quota>
      <Vehicle :data="form.vehicle"></Vehicle>
      <!-- <Cheque v-if="applicationType == 'FIRST'" :data="form.cheque"></Cheque> -->
      <Drivers
        v-if="form.drivers.length > 0"
        :data="form.drivers"
      ></Drivers>

      <div class="check_title">
        {{ $t("message.DataRegistration.check.already_upload_file") }}
      </div>
      <div class="check_file_list">
        <div
          v-for="(item, index) in form.documents"
          :key="item.id"
          class="check_file_list_content"
        >
          <div v-if="item.file">
            <span
              >{{ index + 1 }}.{{
                item.documentType &&
                item.documentType[`name${$t("message.lan")}`]
              }}：</span
            >
            <span class="check_file_name"
              >&nbsp;{{ item.file && item.file.filename }}</span
            >
          </div>
        </div>
      </div>
      <!-- 首次申請，顯示同意checkbox -->
      <div v-if="applicationType === 'FIRST'" class="check_agree">
        <el-checkbox v-model="agreeCheck">{{
          $t("message.hzmbFirstAgree")
        }}</el-checkbox>
        <el-checkbox v-model="agreeCheck2" style="margin-top: 12px">
          {{ $t("message.agree_statement") }}
          (<a
            :href="`${localPath}/files/${
              $i18n.locale === 'PT'
                ? 'hzmb_change_statement_pt'
                : 'hzmb_change_statement'
            }.pdf`"
            target="_blank"
            class="agree-link"
            >{{ $t("hzmbChange.action.statement_detail") }}</a
          >)
        </el-checkbox>
      </div>
    </div>
    <div class="next_btn">
      <GradientBtn white @click="back">{{ $t("message.back") }}</GradientBtn>
      <GradientBtn @click="submit" :loading="loading">{{
        $t("message.DataRegistration.check.submit")
      }}</GradientBtn>
    </div>
  </div>
</template>

<script>
import Quota from "./components/Quota";
import Vehicle from "./components/Vehicle";
// import Cheque from "./components/Cheque";
import Drivers from "./components/Drivers";
import GradientBtn from "../../../components/GradientBtn";
import HzmbApplicationAPI from "../../../api/HzmbApplicationAPI";
import { applicationTypeFilter, applicantTypeFilter } from "@/filters";
export default {
  components: { Quota, Vehicle, Drivers, GradientBtn },
  data() {
    return {
      loading: false,
      form: null,
      agreeCheck: null,
      agreeCheck2: null,
      localPath: process.env.VUE_APP_BASE_LOCAL_PATH,
    };
  },
  computed: {
    // form() {
    //   return this.$store.state.form;
    // },
    // documentType() {
    //   return this.$store.state.documentType;
    // },
    applicationType() {
      return applicationTypeFilter(this.serviceType);
    },
    applicantType() {
      return applicantTypeFilter(this.serviceType);
    },
    vssForm() {
      return this.$store.state.vssForm;
    },
  },
  methods: {
    submit() {
      // 首次申請需要勾選同意checkbox
      if (
        this.applicationType === "FIRST" &&
        (!this.agreeCheck || !this.agreeCheck2)
      ) {
        this.$message({
          type: "error",
          message: this.$t("message.hzmbMoRenew.terms_agree"),
        });
        return;
      }
      this.$confirm(
        this.$t("message.confirm_submit_content"),
        this.$t("message.tips"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let form = this.form;

          delete form.quota.vssMacauAddress;
          // 駕駛人
          form.drivers = form.drivers.map((item) => {
            // 國籍處理
            item.nationality = item.otherNationality
              ? item.otherNationalityText
              : item.nationality;
            return item;
          });
          // 刪除車輛編號和車身後8位
          delete form.vehicle.regAndIdNo;
          // 內地車牌加上“粤”
          if (form.vehicle.mainlandRegistrationNo)
            form.vehicle.mainlandRegistrationNo =
              "粤" + form.vehicle.mainlandRegistrationNo;
          this.loading = true;
          if (this.applicationType == "RENEW") {
            HzmbApplicationAPI.renew(form)
              .then(() => {
                this.loading = false;
                this.$router.push("/success");
              })
              .catch((err) => {
                this.loading = false;
                this.$error(err);
              });
          } else {
            HzmbApplicationAPI.first(form)
              .then(() => {
                this.loading = false;
                this.$router.push("/success");
              })
              .catch((err) => {
                this.loading = false;
                this.$error(err);
              });
          }
        })
        .catch(() => {
          return;
        });
    },
    back() {
      this.$router.push("upload");
    },
    // 獲取vss數據
    getVss() {
      this.loading = true;
      const serviceType = this.$store.state.serviceType;
      const verifyForm = this.$store.state.verifyForm;
      let identType = "BM";
      let identNo = verifyForm.identityNo;
      if (this.applicantType == "COMPANY") {
        if (verifyForm.companyType && verifyForm.companyNo) {
          identType = verifyForm.companyType;
          identNo = verifyForm.companyNo;
        } else {
          this.$message({
            type: "error",
            message: this.$t("message.different_login_type"),
          });
          this.$notify({
            type: "error",
            showClose: false,
            title: this.$t("message.tips"),
            message: this.$t("message.backToHome"),
            position: "bottom-right",
            duration: 4500,
          });
          setTimeout(() => {
            const page = localStorage.getItem("childTempTitle") || "one";
            if (page == "three") {
              this.$router.push("/entryTaxi");
            } else if (page == "two") {
              this.$router.push("/entryBus");
            } else {
              this.$router.push("/entry");
            }
          }, 5000);
          return;
        }
      }
      const spNo = verifyForm.spNo || null;
      const registrationNo = verifyForm.registrationNo || null;
      const identificationNo = verifyForm.identificationNo || null;
      HzmbApplicationAPI.getVss(
        serviceType,
        identType,
        identNo,
        spNo,
        registrationNo,
        identificationNo
      )
        .then((res) => {
          // console.log(res);
          this.loading = false;
          // let application = res.application;
          if (res.success) {
            this.form = this.formatForm(res);
          } else {
            this.loading = false;
            this.$message({
              type: "error",
              message: res.errorMsgs
                .map((item) => {
                  return item.textCn;
                })
                .join("/n"),
            });
            // this.$router.go(-1);
          }
        })
        .catch((err) => {
          this.$error(err);
          // this.$router.go(-1);
        });
    },
    formatForm(res) {
      this.$store.commit("changeVssForm", res);
      let resetForm = {
        quota: {
          macauAddress: {
            textCn: "",
            textPt: "",
          },
        },
        vehicle: {},
        cheque: {},
        drivers:
          this.applicationType == "FIRST"
            ? [
                {
                  macauAddress: {
                    textCn: "",
                    textPt: "",
                  },
                },
              ]
            : [],
      };
      let verifyForm = this.$store.state.verifyForm;
      let application = res.application;
      if (application) {
        let quota = application.quota;
        if (quota) {
          // 電話去掉區號
          if (quota.mainlandPhone) {
            quota.mainlandPhone = quota.mainlandPhone.replace(/86-/g, "");
          }
          if (quota.hkPhone) {
            quota.hkPhone = quota.hkPhone.replace(/852-/g, "");
          }
          // 澳門聯絡地址回顯
          const applyAddress = res.spRemark && res.spRemark.applyAddress;
          const macauAddressText =
            quota.macauAddress && quota.macauAddress.textCn;
          if (applyAddress && applyAddress == macauAddressText) {
            quota.vssMacauAddress = macauAddressText;
          } else {
            quota.vssMacauAddress = "other";
          }
        }
        // 其他國籍處理
        // 電話去掉區號
        let drivers = application.drivers;
        if (drivers && drivers.length > 0) {
          drivers = drivers.map((ele) => {
            if (ele.otherNationality) {
              ele.otherNationalityText = res.nationality;
              ele.nationality = "XXX";
            }
            if (ele.mainlandPhone) {
              ele.mainlandPhone = ele.mainlandPhone.replace(/86-/g, "");
            }
          });
          if (drivers.otherNationality) {
            drivers.otherNationalityText = res.nationality;
            drivers.nationality = "XXX";
          }
        }
        // 內地車牌去除“粤”
        let vehicle = application.vehicle;
        if (vehicle) {
          vehicle.regAndIdNo = vehicle.registrationNo;
          if (vehicle.mainlandRegistrationNo) {
            vehicle.mainlandRegistrationNo =
              vehicle.mainlandRegistrationNo.replace(/(粤|粵)/g, "");
          }
        }
        // 續期spNo默認取接口
        if (this.applicationType == "RENEW") {
          verifyForm.spNo = res.appCdMo;
          resetForm = res.application;
        }
        resetForm = res.application;
      } else {
        let quota = resetForm.quota;
        // 否則根據准入信息預填數據
        if (this.applicantType == "PERSON") {
          quota.personNameCn = res.custCname;
          quota.personNameEn = res.custPname;
          quota.personIdentityNo = verifyForm.identityNo;
        } else {
          quota.companyNameCn = res.custCname;
          quota.companyNameEn = res.custPname;
          quota.companyIdentityType = verifyForm.companyType;
          quota.companyBrNo = verifyForm.companyNo;
        }
        quota.macauMobile = res.custMobile;
        if (this.applicationType == "FIRST") {
          let cheque = resetForm.cheque;
          cheque.amount = (this.config && this.config.amount) || 0;
        }
        if (this.applicationType == "RENEW") {
          verifyForm.spNo = res.appCdMo;
          verifyForm.hzmbSubtype = res.hzmbSubtype;
          this.$store.commit("changeVssForm", verifyForm);
          let vehicle = resetForm.vehicle;
          vehicle.registrationNo = res.plateNo;
          vehicle.regAndIdNo = res.plateNo;
          vehicle.identificationNo = verifyForm.identificationNo;
          if (res.owenerMobileCn)
            quota.mainlandPhone = res.owenerMobileCn.replace(/86-/g, "");
          if (res.owenerEmail) quota.mainlandEmail = res.owenerEmail;
          if (res.plateNoCn) vehicle.mainlandRegistrationNo = res.plateNoCn;
        }
      }
      // console.log("resetForm: ", resetForm);
      return resetForm;
    },
  },
  created() {
    this.serviceType = this.$store.state.serviceType;
    this.getVss();
  },
};
</script>

<style lang="scss" scoped>
.check {
  background: #fff;
  overflow: hidden;
  padding: 14px;
  max-width: 1200px;
  overflow: hidden;
  margin: auto;
}
.check_title {
  max-width: 867px;
  margin: auto;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #262626;
  border-bottom: 3px solid #38959d;
  padding: 16px 0;
}
.check_file_list {
  max-width: calc(867px - 48px);
  width: calc(100% - 48px);
  margin: 24px auto;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 1);
  padding: 24px;
}
.check_file_list_content {
  max-width: 760px;
  margin: auto;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 22px;
}
.check_file_name {
  color: #5ba7ad;
}
/deep/.check_agree {
  max-width: 867px;
  margin: auto;
  .el-checkbox {
    white-space: normal;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .el-checkbox__label {
    font-size: 16px;
  }
}
.agree-link {
  color: #5ba7ad;
}
</style>
